<app-conv-actions-footer-default
  #actionsFooterDefault
  *ngIf="currentlyDisplayedComponent === 'default'"
  (textEvent)="onSendMessage($event)"
  (gotoEvent)="onGoTo($event)"
  [lead]="conversation.lead"
  [sendButtonStatus]="sendButtonStatus"
>
</app-conv-actions-footer-default>
